import { GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";
import { auth, googleProvider } from "../../firebaseConfig";
import { googleCreateAsync } from "./authSlices";
import { useNavigate } from "react-router-dom";
import { Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, RadioGroup, Stack, Radio } from "@chakra-ui/react";
import { useState } from "react";


export const signInWithGoogle = async () => {  
  try {
    const provider = new GoogleAuthProvider();
    const result = await signInWithPopup(auth, provider);
    const user = result.user;

    // ✅ Get correct Google OAuth access token
    const credential = GoogleAuthProvider.credentialFromResult(result);
    const accessToken = credential?.accessToken;

    if (!accessToken) {
      throw new Error("Failed to get access token from Google");
    }

    const userData = {
      uid: user.uid,
      email: user.email,
      displayName: user.displayName,
      photoURL: user.photoURL,
      accessToken, 
    };

    console.log("User Data:", userData);

    // Remove cookie setting from here - we'll set it only after user type validation
    
    return { accessToken, userData };  // ✅ Return user data

  } catch (error) {
    console.error("Error signing in with Google:", error.message);
    throw error;
  }
};

// GoogleLogin Component
const GoogleLogin = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [userType, setUserType] = useState("");

  return (
    <>
      <Button onClick={() => setIsOpen(true)}>Sign in with Google</Button>

      {/* Modal to select user type */}
      <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Select Account Type</ModalHeader>
          <ModalBody>
            <RadioGroup onChange={setUserType} value={userType}>
              <Stack direction="column">
                <Radio value="candidate">Candidate</Radio>
                <Radio value="employer">Employer</Radio>
              </Stack>
            </RadioGroup>
          </ModalBody>
          <ModalFooter>
            <Button 
              colorScheme="blue" 
              onClick={() => signInWithGoogle(navigate, userType)} 
              isDisabled={!userType}
            >
              Continue with Google
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default GoogleLogin;


// Sign Out
const logout = async () => {
  try {
    await signOut(auth);
    console.log("User signed out");
  } catch (error) {
    console.error("Error signing out:", error.message);
  }
};

export { GoogleLogin, logout };
